export default class ContractReadjustment {
  strategy: string;

  rules: Array<string> = [];

  constructor(obj: any = {}) {
    this.strategy = obj.strategy || '';
    this.rules = obj.rules || [];
  }

  public static of(obj: any = {}): ContractReadjustment {
    return new ContractReadjustment(obj || {});
  }

  public static ofList(obj: any[]): ContractReadjustment[] {
    return obj.map(this.of);
  }

  applyNewReadjustment(strategy: string, rules: Array<string>) {
    this.strategy = strategy;
    this.rules = rules;
  }
}
